import React, {useEffect} from "react";
import {
    CarouselProvider,
    Slider,
    Slide,
    ButtonBack,
    ButtonNext
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import "../style/carousel.css"
import {IWallet} from "../types/type";
import EachCarousel from "./EachCarousel";

interface ICarousel {
    wallet : IWallet[]
    deleteWallet : (index : number) => void
}


const WalletList : React.FC<ICarousel> = ({wallet , deleteWallet}) => {




    return (

        <>
            <CarouselProvider
                naturalSlideWidth={100}
                naturalSlideHeight={100}
                totalSlides={wallet.length ?? 0}
                visibleSlides={1}
                currentSlide={wallet.length === 0 ? 0 : wallet.length - 1}
            >
                <Slider>
                    {
                        wallet.map((wallet : IWallet , index) => {
                            return (
                                <Slide index={index} key={wallet.chainId + wallet.address} >
                                    <EachCarousel wallet={wallet} deleteWallet={deleteWallet} seq={index}/>
                                </Slide>
                            )
                        })
                    }
                </Slider>
            </CarouselProvider>


        </>

    );
}
export default WalletList
